import { render } from "./CustomHtml.vue?vue&type=template&id=9562ac46&scoped=true"
import script from "./CustomHtml.vue?vue&type=script&lang=ts"
export * from "./CustomHtml.vue?vue&type=script&lang=ts"

import "./CustomHtml.vue?vue&type=style&index=0&id=9562ac46&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9562ac46"

export default script